import React from 'react';
import {Checkbox, FormGroup} from 'react-bootstrap';
import {Control} from 'react-redux-form';

const RevokeCheckbox = () => (
  <FormGroup>
    <div className="checkbox">
      <Control.checkbox component={Checkbox} model=".revoke_api_access">
          Revoke api access
      </Control.checkbox>
    </div>
  </FormGroup>
);

export default RevokeCheckbox;



// WEBPACK FOOTER //
// ./src/components/admin/app/user-access-tokens/edit/revoke-checkbox.jsx